<template>
    <div class="app-container" :class="$route.meta.class">
        <div
            class="page-banner"
            :style="`background-image: url(${$publicPath}/static/banner/${$route.meta.class}.jpg);`"
        >
            <div class="page-banner__inside width-master">
                <div class="page-banner__title">{{ $route.meta.en_title }}</div>
                <div class="page-banner__subtitle">{{ $route.meta.title }}</div>
                <div class="page-banner__desc">
                    {{ $route.meta.desc }}
                </div>
            </div>
        </div>

        <div class="page-block width-master">
            <div class="page-breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                    >
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <!-- <div class="top-line"></div> -->

         <div class="products-list" v-for="(product, pIndex) in products" :key="pIndex">
            <div class="product-title width-master">{{ product.name }}</div>
            <div class="product-hd">
                <div
                    class="product-model__b"
                    v-for="(item, index) in product.data"
                    :key="index"
                    :class="'product-model__item-' + (index % 4)"
                    :style="
                        `background-image: url(${$publicPath}/static/products/${item.image});`
                    "
                >
                    <div class="content">
                        <h3> {{ item.name }}</h3>
                        <div class="action">
                            <router-link
                                :to="{
                                    name: 'ProductsDetail',
                                    params: { productId: 123 },
                                }"
                                >了解更多</router-link
                            ><v-icon
                                class="co__action-icon"
                                name="md-chevronright"
                            ></v-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="products-list">
            <div class="product-title width-master">英雄系列</div>
            <div class="product-hd">
                <div
                    class="product-model__a"
                    :style="
                       `background-image: url(${$publicPath}/static/products/pp-hero-s@2x.jpg);`
                    "
                >
                    <div class="content">
                        <h3>Hero Series</h3>
                        <div class="sub_h3">英雄系列</div>
                        <div class="action">
                            <router-link
                                class="cb-primary"
                                :to="{
                                    name: 'ProductsDetail',
                                    params: { productId: 123 },
                                }"
                                >了解更多</router-link
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ProductsIndex",
    data() {
        return {
            name: "ProductsIndex",
            products: [
                {
                    name: "PVC",
                    data: [
                        {
                            name: "PVC-U环保排水管",
                            image: "pvc-u-1@2x.jpg",
                            link: "",
                        },
                        {
                            name: "PVC-U环保排水管",
                            image: "pvc-u-2@2x.jpg",
                            link: "",
                        },
                        {
                            name: "PVC精品家装线管、PE-RT采暖管",
                            image: "pvc-u-3@2x.jpg",
                            link: "",
                        },
                        {
                            name: "PVC难燃电线槽管",
                            image: "pvc-u-4@2x.jpg",
                            link: "",
                        },
                    ],
                },
                {
                    name: "PR-R",
                    data: [
                        {
                            name: "PP-R精品家装管",
                            image: "pp-r-1@2x.jpg",
                            link: "",
                        },
                        {
                            name: "PP-R环保健康饮用水管",
                            image: "pp-r-2@2x.jpg",
                            link: "",
                        },
                    ],
                },
                {
                    name: "PE",
                    data: [
                        {
                            name: "PE燃气管道",
                            image: "pe-1@2x.jpg",
                            link: "",
                        },
                        {
                            name: "聚乙烯（PE）给水管",
                            image: "pe-2@2x.jpg",
                            link: "",
                        },
                    ],
                },
                {
                    name: "其他",
                    data: [
                        {
                            name: "克拉管",
                            image: "p-o-1@2x.jpg",
                            link: "",
                        },
                        {
                            name: "缠绕管与波纹管",
                            image: "p-o-2@2x.jpg",
                            link: "",
                        },
                        {
                            name: "铝塑-卫生饮用水管",
                            image: "p-o-3@2x.jpg",
                            link: "",
                        },
                        {
                            name: "通信、电力管",
                            image: "p-o-4@2x.jpg",
                            link: "",
                        },
                    ],
                },
            ],
        };
    },
};
</script>
<style lang="scss"></style>
